import Vue from 'vue';
import { VueConstructor } from 'vue/types/vue';
import Component from 'vue-class-component';
import { ui, PaymentProviders } from '@/constants';
import CmgPayeezyForm from '../../payment/CmgPayeezyForm/CmgPayeezyForm.vue';
import CmgChaseForm from '../../payment/CmgChaseForm/CmgChaseForm.vue';

@Component({
  name: 'CmgAddCreditOrDebitCardModal',
  components: {
    CmgPayeezyForm,
    CmgChaseForm,
  },
})
export default class CmgAddCreditOrDebitCardModal extends Vue {
  providerId = '';
  visibilityWatcher?: () => void;
  paymentComponent: unknown = null;

  get paymentArgs() {
    return this.$appStore.state.ui.modals.addCreditOrDebitCardModal.args;
  }

  get oneTimePayment(): boolean {
    return (this.paymentArgs && this.paymentArgs.oneTimePaymentUse) || false;
  }

  get isMobile(): boolean {
    return this.$appStore.state.ui.clientWidth <= ui.breakpoints.phoneLgMax;
  }

  get closeButtonImageUrl(): string {
    return this.$appStore.state.cms.images.buttons.xDarkBrown.default;
  }

  get blankCreditCardImgUrl(): string {
    return this.$appStore.state.cms.images.blankCreditCard.default;
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.addCreditOrDebitCardModal.visible;
  }

  onClose() {
    this.$services.ui.setModalVisibility('addCreditOrDebitCardModal', false);
    this.$services.ui.focusBack();
    if (this.paymentArgs && this.paymentArgs.onClose) {
      this.paymentArgs.onClose();
    }
  }

  mounted() {
    this.visibilityWatcher = this.$appStore.watch(
      state => state.ui.modals.addCreditOrDebitCardModal.visible,
      async (isVisible: boolean) => {
        if (isVisible) {
          this.paymentComponent = '';
          try {
            // First looking if provider id was passed into modal.
            if (this.paymentArgs && this.paymentArgs.providerId) {
              this.providerId = this.paymentArgs.providerId;
            } else {
              this.providerId = this.$services.payment.getPaymentProvider(this.$appStore.state.ui.countryProfile.countryCode);
            }
            this.paymentComponent = this.getPaymentComponent();
          } catch (error) {
            this.onClose();
            this.$services.logger.error('Could not load payment form', error);
            return this.$services.ui.setModalVisibility('globalErrorToast', true);
          }
        } else {
          //reset the paymentComponent
          this.paymentComponent = '';
        }
      },
    );
  }

  destroyed() {
    if (this.visibilityWatcher) {
      this.visibilityWatcher();
    }
  }

  private getPaymentComponent(): VueConstructor<Vue> {
    switch (this.providerId) {
      case PaymentProviders.Payeezy:
        return CmgPayeezyForm;
      case PaymentProviders.Chase:
        return CmgChaseForm;
      default:
        throw new Error('No payment form existing for this provider');
    }
  }
}
